const InitMediaBlocks = () => {
  watchForPostLinkHover();
}

export const watchForPostLinkHover = () => {
  const blocks = document.querySelectorAll('.media-block.type_post, .media-block-wrapper.type_post, .results_card');

  if(blocks){
    blocks.forEach(block => {
      const links = block.querySelectorAll('.media-block-link, a');
      const underlineEl = block.querySelector('.animated_underline');
      
      if(links && !!underlineEl){
        links.forEach(link => {
          if(!link.hoverEventWatching){
            link.hoverEventWatching = true;
            let hoverRemoval = null;
            
            link.addEventListener('mouseenter', ()=>{
              block.classList.add('hover');
              underlineEl.classList.add('hover');
              clearTimeout(hoverRemoval);
            });

            link.addEventListener('mousemove', ()=>{
              if(!underlineEl.classList.contains('hover')){
                underlineEl.classList.add('hover');
                block.classList.add('hover');
              }
              clearTimeout(hoverRemoval);
            });

            link.addEventListener('mouseout', ()=>{
              underlineEl.classList.remove('hover');
              block.classList.remove('hover');
              block.classList.add('removing-hover');
              clearTimeout(hoverRemoval);
              hoverRemoval = setTimeout(()=>{
                block.classList.remove('removing-hover');
                hoverRemoval = null;
              }, 600);
            });
          }
        });
      }
    });
  }
}

export {InitMediaBlocks};